var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.display)?_c('div',[_c('fm-title',{attrs:{"title-text":"身份证"}}),_c('worker-id-card-img',{attrs:{"worker-data":_vm.editData || _vm.sourceData,"funs":{
      get: true,
      update: true
    }},on:{"idcardFileChange":_vm.idcardFileChange}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }